import { getBtcApiConfig } from '../getBtcApiConfig';
import { TNetworkMode } from '../types';

/**
 * Get the current fee rate in satoshis per byte.
 *
 * @note based on https://mempool.space/signet/docs/api/rest#get-recommended-fees
 *
 * @param mode - the network mode
 * @returns the fee rate in satoshis per byte
 */
export async function getFeeRate(mode?: TNetworkMode): Promise<number> {
  const { mempoolApiUrl } = getBtcApiConfig(mode);
  const url = `${mempoolApiUrl}/api/v1/fees/recommended`;
  const response = await fetch(url);
  const data = await response.json();
  return data.fastestFee;
}
